import styled from "styled-components";
import { colorPalette, typeScale } from "../../utils/theme";

// Container for the tag
export const TagContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    prop !== "backgroundColor" && prop !== "color" && prop !== "size",
})<{ backgroundColor: string; color: string; size: string }>`
  height: ${({ size }) => (size === "L" || size === "M" ? "36px" : "24px")};
  padding: ${({ size }) =>
    size === "L" || size === "M" ? "8px 12px" : "4px 8px"};
  border-radius: ${({ size }) =>
    size === "L" || size === "M" ? "8px" : "4px"};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* The height is fixed, so a label that wrapped would spill out of the tag. */
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  ${typeScale.bodySM}
`;

// Optional logo on the left side
export const TagLogo = styled.img`
  height: 14px;
  width: 14px;

  @media (max-width: 767.98px) {
    margin-right: 0px;
  }
`;

// Tooltip icon styling
export const TagTooltipIcon = styled.span`
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: ${colorPalette.successMedium};

  &:hover {
    color: #ededed;
  }
`;
